export default "__VITE_ASSET__d455aea6__"